import React from 'react';

import { Redirect } from "react-router-dom";

import PuzzleMenu from './puzzleMenu/PuzzleMenu';
import GamePage from './game/GamePage';
import Creditos from './creditos/Creditos';
import Rank from './rank/Rank';

export const Home = () => <PuzzleMenu/>

export const Ranking = () => <Rank/>

export const Credito= () =>
  <div className="creditos pages">
    <Creditos/>
  </div>
export const Game = ({match}) => {
  const gameName = match.params.gameName;
  return(
    <div className="pageGame pages">
      <GamePage gameName={gameName}/>
    </div>
  );
};

export const NotFound = ({location}) =>
  <Redirect to={"/inicio"} />
